export { IndexCatalogos } from "./menu/view";


// WEBPACK FOOTER //
// ./app/features/general/catalogos/index.tsx